import { render, staticRenderFns } from "./NavVerticalLabInmunologia.vue?vue&type=template&id=7e19cc4e&scoped=true"
import script from "./NavVerticalLabInmunologia.vue?vue&type=script&lang=js"
export * from "./NavVerticalLabInmunologia.vue?vue&type=script&lang=js"
import style0 from "./NavVerticalLabInmunologia.vue?vue&type=style&index=0&id=7e19cc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e19cc4e",
  null
  
)

export default component.exports